import {types} from './types';

const initialState = {
    list: [],
}

export function codeCountryReducer(state = initialState, action) {
    switch (action.type) {
        case types.SET_LIST_CODE_COUNTRY:
            return { ...state, list: action.payload};
        default:
            return state
    }
}